






















































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import InvestmentLineChart from "@/shared/components/charts/InvestmentLineChart.vue";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import {
  AdvisorEventType,
  InvestmentCustodian
} from "@/shared/types";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";

@Component({
  components: {
    InvestmentLineChart
  }
})
export default class UmbInvestmentAccountPage extends mixins(ErrorsMixin) {

  formatCurrency = formatCurrency;
  playVideo = false;
  partnerPortalStore = usePartnerPortalStore();
  investmentDailyBalance = useInvestmentDailyBalanceStore();
  advisorStore = useUserAdvisorStore();

  mounted (): void {
    this.partnerPortalStore.getPartnerPortalStatus();
    this.investmentDailyBalance.loadCurrentDailyBalance();
  }

  get umbInvestmentManagementCutoffHasPassed (): boolean {
    const dateNow = moment();
    const cutoffDate = moment("10/31/2025 23:59:59");

    return dateNow.isAfter(cutoffDate);
  }

  get hasInvestmentBalance (): boolean {
    return this.investmentBalance > 0;
  }

  get investmentBalance (): number {
    return this.investmentDailyBalance.umbCurrentBalanceOrNull
        ? this.investmentDailyBalance.umbCurrentBalanceOrNull.balance
        : this.investmentDailyBalance.investmentBalanceOnFileAmount as number;
  }

  get investmentBalanceDate (): string {
    return moment(
        this.investmentDailyBalance.umbCurrentBalanceOrNull ? this.investmentDailyBalance.umbCurrentBalanceOrNull.date
            : this.investmentDailyBalance.investmentBalanceOnFileDate as string).format("MMM DD");
  }

  get isLoaded (): boolean {
    return this.investmentDailyBalance.currentBalanceIsLoaded;
  }

  get isLoading (): boolean {
    return !this.isLoaded;
  }

  get titleCopy (): string {
    if (this.isLoaded) {
      return "Investment Balance";
    }

    return "Loading...";
  }

  get umbInvestmentCustodian (): InvestmentCustodian {
    return InvestmentCustodian.Umb;
  }

  toggleVideo (): void {
    this.playVideo = !this.playVideo;
  }

  logEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.SsoInvestmentLinkClick);
  }
}
